import React from 'react';
import t from '@guestyci/localize/t.macro';
import { Button, Heading, Stack, Text, Card } from '@guestyci/arc';
import { FormLayout } from '../../layout';
import { getSessionEmail, getSessionFirstName } from '../../utils/widgetConfig';

const WelcomeStep = ({ onContinue }) => {
  const firstName = getSessionFirstName();
  const userEmail = getSessionEmail();
  
  return (
    <FormLayout>
      <Stack spacing={10} justify="between" className="gst-flex-1">
        <Stack spacing={6}>
          <Stack spacing={3}>
            <Heading variant="h1">
              {t('Hi {firstName},', { firstName })}
              <br />
              {t('Welcome to Guesty!')}
            </Heading>
            <Text className="gst-text-muted-foreground">
              {t('We are excited to help you streamline your property management business.')}
            </Text>
          </Stack>

          <Card className="gst-bg-information-foreground/20 gst-pt-3 gst-px-4 gst-pb-4 gst-border-0 gst-shadow-none">
            <Stack spacing={2}>
              <Text size="lg" className="gst-font-semibold">{t('What happens next:')}</Text>
                <ul className="gst-list-disc gst-pl-4 gst-space-y-1 gst-text-sm">
                  <li>{t('Create a secure password for your account')}</li>
                  <li>{t('Set up multi-factor authentication')}</li>
                  <li>{t('Add a payment method')}</li>
                </ul>
            </Stack>
          </Card>
        </Stack>

        <Stack spacing={2} align="start" className="gst-w-full">
          <Button onClick={onContinue} className="gst-w-full">
            {t('Get started')}
          </Button>
          <Text type="secondary" size="base" className="gst-w-full gst-text-left">
            {t('Registering with {email}', {email: userEmail})}
          </Text>
        </Stack>
      </Stack>
    </FormLayout>
  );
};

export default WelcomeStep;
